var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._b({staticClass:"bi icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","role":"img","focusable":"false","aria-hidden":"true","width":"1em","height":"1em","fill":"currentColor","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 16 16"},domProps:{"innerHTML":_vm._s(_vm.path)}},'svg',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }